<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <mat-accordion formArrayName="vehicles">
    <div class="form_sections" *ngFor="let v of vehicles.controls; let i = index">
      <mat-expansion-panel [expanded]="i == 0" formGroupName="{{i}}">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>
              <u>
                <span *ngIf="!v.get('registration_number').value">Vehicle</span>
                <span *ngIf="v.get('registration_number').value">{{ v.get('registration_number').value
                  | uppercase }}</span>
                <span *ngIf="v.get('make').value"> - {{ v.get('make').value }}</span>
                <span *ngIf="v.get('model').value"> - {{ v.get('model').value }}</span>
              </u>
              <a (click)="removeHorseboxes(i)" title="Remove Horsebox" class="btn btn-danger btn-sm p-1 ml-3"
                *ngIf="i > 0"><i class="mdi mdi-delete"></i></a>
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="cal_body">
          <h6 class="text-white">Vehicle Details</h6>
          <div class="row">
            <div class="col-md-6 mb-3">
              <!-- <div class="input-group mb-3"> -->
              <input type="text" class="form-control form-control-sm" placeholder="Registration Number" required
                name="registration_number" formControlName="registration_number" appUpperCase
                (change)="onRegistrationNumberChange($event, i)" (input)="toUppercase($event)"
                [ngClass]="{ 'is-invalid': (v.get('registration_number').touched || submitted) && v.get('registration_number').errors?.required }">
              <!-- <span class="input-group-text text-white dark-green-bg pt-0 pb-0">Search</span> -->
              <!-- </div> -->
              <div class="invalid-feedback"
                *ngIf="(v.get('registration_number').touched || submitted) && v.get('registration_number').errors?.required">
                Registration number is required.
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <input type="text" class="form-control form-control-sm" placeholder="Make" required name="make"
                  formControlName="make"
                  [ngClass]="{ 'is-invalid': (v.get('make').touched || submitted) && v.get('make').errors?.required }">
                <div class="invalid-feedback"
                  *ngIf="(v.get('make').touched || submitted) && v.get('make').errors?.required">
                  Make is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input type="text" class="form-control form-control-sm" placeholder="Model" required name="model"
                formControlName="model"
                [ngClass]="{ 'is-invalid': (v.get('model').touched || submitted) && v.get('model').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(v.get('model').touched || submitted) && v.get('model').errors?.required">
                Model is required.
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

  </mat-accordion>
  <div class="quote-card">

    <div class="row">
      <div class="col-md-6">
        <!-- Select Cover -->
        <div class="mb-4">
          <label class="section-label">Select Cover <span class="text-danger">*</span></label>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select formControlName="excess_protect_cover_id" required (selectionChange)="onCoverChange()">
              <mat-option *ngFor="let vw of excessProtectOptions.result" [value]="vw.id">
                {{ vw.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Premium Section -->
        <h5 class="section-title">Premium</h5>

        <div *ngIf="quote_type !=3">
          <div class="premium-row">
            <span>Premium Excl IPT</span>
            <span>£{{ selectedPremium?.rate_excl_ipt || 0 | number:'1.2-2' }}</span>
          </div>

          <div class="premium-row">
            <span>Insurance Premium Tax (12%)</span>
            <span>
              £{{
              (selectedPremium?.rate_incl_ipt - selectedPremium?.rate_excl_ipt) || 0
              | number:'1.2-2'
              }}
            </span>
          </div>

          <div class="premium-row">
            <span>Peliwica Fee</span>
            <span>£0.00</span>
          </div>

          <hr />

          <div class="premium-row total">
            <span>Total Premium Including IPT</span>
            <span>£{{ selectedPremium?.rate_incl_ipt || 0 | number:'1.2-2' }}</span>
          </div>
        </div>

        <div *ngIf="quote_type ==3 && mtaFinancials">
          <div class="premium-row">
            <span>Premium Excl IPT</span>
            <span>£{{ mtaFinancials.adjustment_display_amount | number:'1.2-2' }}</span>
          </div>

          <div class="premium-row">
            <span>Insurance Premium Tax (12%)</span>
            <span>
              £{{ mtaFinancials.adjustment_display_ipt | number:'1.2-2' }}
            </span>
          </div>

          <div class="premium-row">
            <span>Peliwica Fee</span>
            <span>£0.00</span>
          </div>

          <hr />

          <div class="premium-row total">
            <span>Total Premium Including IPT</span>
            <span>£{{ mtaFinancials.adjustment_display_total | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-md-12  text-right"><button class="btn btn-success btn-sm">{{quote_type == 3 ? 'Proceed with MTA Changes':'Proceed'}}</button></div>
  </div>
</form>